interface Feedback {
  activeKey: string;
}
const feedback = {
  namespaced: true,
  state: {
    activeKey: '1',
  },
  getters: {
    getActiveKey(state: Feedback) {
      return state.activeKey;
    },
  },
  mutations: {
    updateActiveKey(state: Feedback, data: any) {
      state.activeKey = data;
    },
  },
};

export default feedback;
